module.exports = __webpack_public_path__ + "img/p3.b759c98a.png";